const $ = (el) => document.querySelector(el);
const $$ = (el) => document.querySelectorAll(el);

class Tabs {
  constructor() {
    let hasTabs = $('.tabs');

    if (hasTabs) {
      $$('.tab_btn').forEach((btn) => {
        btn.addEventListener('click', () => {
          const dataTab = btn.getAttribute('data-tab');

          this.removeActiveClass('.tab_btn, .tab_content');

          btn.classList.add('active');
          console.log(dataTab);
          if (dataTab === 'one') {
            $('.tab_contents').classList.add('first-tab');
          } else {
            $('.tab_contents').classList.remove('first-tab');
          }

          $(`.tab_content[data-tab="${dataTab}"]`).classList.add('active');

          this.activeTabTitle(dataTab);

          let prev = btn.previousElementSibling;
          let next = btn.nextElementSibling;

          if (prev) {
            prev.classList.add('can-click');
          }

          if (next) {
            next.classList.add('can-click');
          }

        });
      });


      $$('.btn_prev, .btn_next').forEach((btn) => {
        btn.addEventListener('click', () => {
          const dataTab = btn.getAttribute('data-tab');
          $(`.tab_btn[data-tab="${dataTab}"]`).click();
        });
      });
    }
  }

  removeActiveClass(elmClass) {
    $$(elmClass).forEach((elm) => {
      elm.classList.remove('active');
    });
  }

  activeTabTitle (tab) {
    this.removeActiveClass('.tab_names .name');

    if (tab == 'one' || tab == 'two') {
      $('.tab_names > .name').classList.add('active');
    }

    if (tab == 'three' || tab == 'four') {
      $('.tab_names > .name + .name').classList.add('active');
    }
  }
}

export default Tabs;